import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faEye,
  faPen,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import styles from "../../masters/master.css";
import apiUrl from "../../apiUrlConstant";
import { withRouter, Link } from "react-router-dom";
import AlertsTable from "./AlertsTable";
import TopHeader from "../../layout/TopHeader";
import BottomNav from "../../layout/BottomNav";
import Dropdown from "react-bootstrap/Dropdown";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Modal, Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { ReactMultiEmail } from "react-multi-email";
import axios from "axios";
import * as Yup from "yup";
import { PopupMessage } from "../../utils/utils";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";
import { getUserType } from "../../utils/index";
const selectStyles = {
  border: "0",
  background: "#ddd",
};
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    //assetId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    //brandId: Yup.number().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({});
}

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

var tableCounter = 0;
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class Alerts extends React.Component {
  state = {
    dropdownValue: "Select Months",
    isOpen: false,
    frequency: "",
    leaseData: "LEASE EXPIRY",
    counter: Math.random(),
    brandSelected: [],
    selectedValue: [],
    setSelectedValue: [],
    leaseSelected: [],
    countries: [],
    monthsArr: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    assetsList: [],
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    states: [],
    assetTypes: [],
    assets: [],
    subAssets: [],
    countries: [],
    states: [],
    districts: [],
    cities: [],
    assetType: "",
    asset: "",
    subAsset: "",
    cityId: "",
    url: `${apiUrl.apiUrl.url}/user-alert/create-alert`,
    additionParams: "",
    financialYearOne: "",
    financialYearTwo: "",

    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",

    leaseList: [],
    formResponseData: [],
    formResponseData1: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    initialValues: {
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      brandCatId: "",
      brandName: [],
      leaseId: "",
      chargeTypeSelected: [],
      financialYear: "",
      chargeType: "",
      financialYearOne: "Period 1",
      financialYearTwo: "Period 2",
      //assetId: "",
    },
    initialValuesAlertSettings: {
      assetTypeId: "",
      assetId: "",
      subAssetId: "",
      towerName: "",
      assetName: "",
      subAssetName: "",
      assetType: "",
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      frequencySelected: [],
    },
  };

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });
  setValue(e) {
    this.setState({ dropdownValue: e });
  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        this.state.initialValues.brandId = [];
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, { headers })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type

      this.state.leaseSelected = [];
      if (newValue.length == 0) {
        this.state.initialValues.leaseId = "";
      } else {
        this.state.initialValues.leaseId = [];
      }
      if (newValue.length > 0 && newValue[0].value == 0) {
        this.state.leaseSelected.push({
          value: newValue[0].value,
          label: newValue[0].label,
        });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(this.state.leaseList[i].id);
          }
        }
      } else {
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push(newValue[i].value);
          this.state.selectedValue.push(newValue[i].value);
          this.state.leaseSelected.push({
            value: newValue[i].value,
            label: newValue[i].label,
          });
        }
      }
      this.setState({});

      //console.log("setting new leases", this.state.leaseSelected);
    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?alert=true&cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {
      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {
      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
      this.getAssetsListByBrand();
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_charge_type") {
      //change_lease_month
      //this.state.initialValues.chargeType = newValue.value;
      //this.state.initialValues.dataUOMName = newValue.label;

      console.log(this.state.initialValues, "initial valuyes");
      this.state.initialValues.chargeTypeSelected = [];
      //this.state.leaseSelected= [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.chargeTypeSelected.push(newValue[i].value);
        //this.state.selectedValue.push(newValue[i].value);
        //this.state.leaseSelected.push({  'value' : newValue[i].value, 'label': newValue[i].label });
      }
    } else if (actionMeta == "change_financial_yearone") {
      //change_lease_month
      this.state.initialValues.financialYearIdOne = newValue.value;
      this.state.initialValues.financialYearOne = newValue.label;
    } else if (actionMeta == "change_financial_yeartwo") {
      //change_lease_month
      this.state.initialValues.financialYearIdTwo = newValue.value;
      this.state.initialValues.financialYearTwo = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };

  BrandList() {
    const list = this.state.brandSelected;
    const listItems = list.map((number) => number.label + ",");
    return <label>{listItems}</label>;
  }

  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/unit-detail/get-asset-types`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
  }

  frequencyChange(e) {
    console.log(e, "eee");
    this.state.frequencySelected = [];
    this.state.initialValuesAlertSettings.freqId = [];
    for (let i = 0; i < e.length; i++) {
      this.state.initialValuesAlertSettings.freqId.push(e[i].value);
      this.state.frequencySelected.push({
        value: e[i].value,
        label: e[i].label,
      });
    }
    this.setState({});
  }

  constructor(props) {
    super(props);
  }

  getLeaseExpiry(e) {
    this.setState({
      leaseData: e.target.outerText,
      counter: Math.random(),
    });
  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  render() {
    return this.renderForm();
  }

  renderForm() {
    return (
      <div className="alerts">
        <TopHeader />
        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.leaseSelected = [];
            this.state.initialValues.chargeTypeSelected = [];
            this.state.chargeTypeSelected = [];
            this.state.financialYearOne = "";
            this.state.financialYearTwo = "";
            this.state.counter = Math.random();
            this.setState({});
          }}
          onSubmit={(values, actions) => {
            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var lease_id = this.state.initialValues.leaseId;

            this.state.additionParams = `brandId=${brand_id}&assetId=${asset_id}&leaseId=${lease_id}`;
            this.setState({});

            this.setState({ counter: Math.random() });

            console.log("lease ids", lease_id, this.state.additionParams);
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <div className="unitFormContainerNew">
              <Form autoComplete="off">
                <div className="container">
                  <div className="row">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Country
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="countryId"
                                isSearchable="true"
                                onChange={(e) => {
                                  this.handleChangeCountry(e, "changecountry");
                                }}
                                value={{
                                  label: this.state.initialValues.countryName,
                                  value: this.state.initialValues.countryId,
                                }}
                                options={this.state.countries.map((item) => ({
                                  label: item.country_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="countryId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Asset Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="assetId"
                                onInputChange={this.getAssetsList}
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_asset_name");
                                }}
                                value={{
                                  label: this.state.initialValues.assetName,
                                  value: this.state.initialValues.assetId,
                                }}
                                options={this.state.assetsList.map((item) => ({
                                  label: item.asset_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="assetId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>

                        {/* <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Brand Category
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="brandCatId"
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "brand_category");
                              }}
                              value={{
                                label: this.state.initialValues.brandCatName,
                                value: this.state.initialValues.brandCatId,
                              }}
                              options={this.state.brandCatList.map((item) => ({
                                label: item.category_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="brandCatId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div>
                    </div> */}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="stateId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_state");
                                }}
                                value={{
                                  label: this.state.initialValues.state_name,
                                  value: this.state.initialValues.state_id,
                                }}
                                options={this.state.states.map((item) => ({
                                  label: item.state_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="stateId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Brand Name
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="brandId"
                                isMulti
                                closeMenuOnSelect={true}
                                onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  this.valueChange(e, "change_brand");
                                }}
                                value={this.state.brandSelected}
                                options={this.state.brandList.map((item) => ({
                                  label: item.brand_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="brandId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="districtId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_district");
                                }}
                                value={{
                                  label: this.state.initialValues.districtName,
                                  value: this.state.initialValues.districtId,
                                }}
                                options={this.state.districtList.map(
                                  (item) => ({
                                    label: item.district_name,
                                    value: item.id,
                                  })
                                )}
                              />

                              <ErrorMessage
                                name="districtId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Lease Number
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="leaseId"
                                isMulti
                                onInputChange={this.handleChange}
                                onChange={(e) => {
                                  this.valueChange(e, "change_lease_number");
                                }}
                                value={this.state.leaseSelected}
                                options={this.state.leaseList.map((item) => ({
                                  label: item.lease_code,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="leaseId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City
                            </label>
                            <div className="col-sm-7">
                              <Select
                      className="basic-single custom-select-style"
                      classNamePrefix="custom-select-style-inner"
                                name="cityId"
                                // onInputChange={this.handleChange}
                                // onChange={}
                                onChange={(e) => {
                                  //handleChange(e);
                                  this.valueChange(e, "change_city");
                                }}
                                value={{
                                  label: this.state.initialValues.cityName,
                                  value: this.state.initialValues.cityId,
                                }}
                                options={this.state.cityList.map((item) => ({
                                  label: item.city_name,
                                  value: item.id,
                                }))}
                              />

                              <ErrorMessage
                                name="cityId"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Asset Name
                          </label>
                          <div className="col-sm-7">
                            <Select
                              className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                              name="assetId"
                              onInputChange={this.getAssetsList}
                              // onInputChange={this.handleChange}
                              // onChange={}
                              onChange={(e) => {
                                //handleChange(e);
                                this.valueChange(e, "change_asset_name");
                              }}
                              value={{
                                label: this.state.initialValues.assetName,
                                value: this.state.initialValues.assetId,
                              }}
                              options={this.state.assetsList.map((item) => ({
                                label: item.asset_name,
                                value: item.id,
                              }))}
                            />

                            <ErrorMessage
                              name="assetId"
                              component="div"
                              className="text-red"
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 offset-lg-6">
                      <div className="btnContainer">
                        <div>
                          <button type="submit" d1isabled={isSubmitting}>
                            View
                          </button>
                          <button type="reset" d1isabled={isSubmitting}>
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          )}
        </Formik>
        <div className="container alertsContainer">
          <div className="row" style={{ width: "100%" }}>
            <div className="col-lg-12 mt-4">
              <div className="row">
                <div className="col-lg-6 offset-lg-6 text-end">
                  <Dropdown
                    onSelect={(e) => {
                      this.setValue(e);
                    }}
                  >
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      {this.state.dropdownValue}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      <Dropdown.Item
                        eventKey="15 Days"
                        onClick={(e) => {
                          this.setState({
                            frequency: "15 Days",
                            counter: Math.random(),
                          });
                        }}
                      >
                        15 Days
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="1 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "1 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        1 Months
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="2 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "2 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        2 Months
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="3 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "3 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        3 Months
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="4 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "4 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        4 Months
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="5 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "5 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        5 Months
                      </Dropdown.Item>
                      <Dropdown.Item
                        eventKey="6 Months"
                        onClick={(e) => {
                          this.setState({
                            frequency: "6 Months",
                            counter: Math.random(),
                          });
                        }}
                      >
                        6 Months
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <button
                    type="button"
                    onClick={(e) => {
                      this.openModal();
                    }}
                    className="alertsBtn createAlert"
                  >
                    Create Alert
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <button
                    type="button"
                    className="alertsBtn"
                    onClick={(e) => {
                      this.getLeaseExpiry(e);
                    }}
                  >
                    LEASE EXPIRY
                  </button>
                  <button
                    type="button"
                    className="alertsBtn"
                    onClick={(e) => {
                      this.getLeaseExpiry(e);
                    }}
                  >
                    LOCKIN EXPIRY
                  </button>
                  <button
                    type="button"
                    type="button"
                    className="alertsBtn"
                    onClick={(e) => {
                      this.getLeaseExpiry(e);
                    }}
                  >
                    RENT
                  </button>
                  {/* <button
                    type="button"
                    type="button"
                    className="alertsBtn"
                    onClick={(e) => {
                      this.getLeaseExpiry(e);
                    }}
                  >
                    FITOUT SECURITY DEPOSIT
                  </button> */}
                </div>
              </div>
              <AlertsTable
                leaseData={this.state.leaseData}
                key={this.state.counter}
                frequency={this.state.frequency}
                additionParams={this.state.additionParams}
              />
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <Modal
                show={this.state.isOpen}
                onHide={this.closeModal}
                size="md"
                className="documentModal saveAlertModal"
              >
                <Modal.Body>
                  <h2 className="text-center">Create Alert</h2>
                  <Formik
                    initialValues={this.state.initialValuesAlertSettings}
                    enableReinitialize
                    onSubmit={(values, actions) => {
                      values.emails = this.state.emails;
                      values.assetId = this.state.initialValues.assetId;
                      values.brandId = this.state.initialValues.brandId;
                      var self = this;
                      axios({
                        method: "post",
                        url: this.state.url,
                        data: values,
                      }).then(function (response) {
                        if (!response.data.success) {
                          actions.setSubmitting(false);
                          actions.setErrors(response.data);
                          alert(response.data.message);
                        } else {
                          self.setState({
                            messsagePopup: true,
                            popupContent: "Data Saved Successfully",
                          });
                          self.setState({
                            // url: `${apiUrl.apiUrl.url}/asset/create-tower`,
                            // self.setState({ redirect: true });
                            redirect: true,
                            emails: [],
                            frequencySelected: [],
                            isOpen: false,
                            initialValuesAlertSettings: {
                              assetTypeId: "",
                              assetId: "",
                              subAssetId: "",
                              towerName: "",
                              assetName: "",
                              subAssetName: "",
                              assetType: "",
                              countryId: "",
                              stateId: "",
                              districtId: "",
                              cityId: "",
                              frequencySelected: [],
                            },
                          });
                        }
                      });
                    }}
                  >
                    {({
                      values,

                      errors,

                      touched,

                      handleChange,

                      handleBlur,

                      handleSubmit,

                      isSubmitting,
                    }) => (
                      <div className="unitFormContainer saveAlert">
                        <Form autoComplete="off">
                          <div className="container">
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Report Type{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7 reactSelect">
                                      <Select
                                        styles={selectStyles}
                                        name="reportType"
                                        onChange={(e) => {
                                          this.state.initialValuesAlertSettings.reportType =
                                            e.label;
                                          this.state.initialValuesAlertSettings.reportId =
                                            e.value;
                                          this.setState({});
                                        }}
                                        value={{
                                          label:
                                            this.state
                                              .initialValuesAlertSettings
                                              .reportType,
                                          value:
                                            this.state
                                              .initialValuesAlertSettings
                                              .reportId,
                                        }}
                                        options={[
                                          {
                                            value: "lockin",
                                            label: "Lease Lockin",
                                          },
                                          {
                                            value: "expiry",
                                            label: "Lease Expiry",
                                          },
                                          {
                                            value: "Rent",
                                            label: "Lease Rent",
                                          },
                                          {
                                            value: "security-deposit",
                                            label: "Security Deposit",
                                          },
                                          {
                                            value: "fitout-security-deposit",
                                            label: "Fitout Security Deposit",
                                          },
                                        ].map((item) => ({
                                          label: item.label,
                                          value: item.value,
                                        }))}
                                      />
                                      <ErrorMessage
                                        name="reportType"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Week Day <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7 reactSelect">
                                      <Select
                                        name="weekDay"
                                        onChange={(e) => {
                                          this.state.initialValuesAlertSettings.weekLabel =
                                            e.label;
                                          this.state.initialValuesAlertSettings.weekId =
                                            e.value;
                                          this.setState({});
                                        }}
                                        value={{
                                          label:
                                            this.state
                                              .initialValuesAlertSettings
                                              .weekLabel,
                                          value:
                                            this.state
                                              .initialValuesAlertSettings
                                              .weekId,
                                        }}
                                        options={[
                                          { label: "Mon", value: 1 },
                                          { label: "Tue", value: 2 },
                                          { label: "Wed", value: 3 },
                                          { label: "Thus", value: 4 },
                                          { label: "Fri", value: 5 },
                                          { label: "Sat", value: 6 },
                                          { label: "Sun", value: 7 },
                                        ].map((item) => ({
                                          label: item.label,
                                          value: item.value,
                                        }))}
                                      />
                                      <ErrorMessage
                                        name="weekDay"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Email Id's
                                    </label>
                                    <div className="col-sm-7">
                                      <ReactMultiEmail
                                        placeholder="Input your Email Address"
                                        emails={this.state.emails}
                                        onKeyPress={(e) => {
                                          //e.key === 'Enter' && e.preventDefault();
                                          console.log("callingg....");
                                        }}
                                        onChange={(_emails: string[]) => {
                                          console.log("change event");
                                          this.setState({ emails: _emails });
                                        }}
                                        getLabel={(
                                          email: string,
                                          index: number,
                                          removeEmail: (index: number) => void
                                        ) => {
                                          return (
                                            <div data-tag key={index}>
                                              {email}
                                              <span
                                                data-tag-handle
                                                onClick={() =>
                                                  removeEmail(index)
                                                }
                                              >
                                                ×
                                              </span>
                                            </div>
                                          );
                                        }}
                                      />
                                      <br />
                                      <ErrorMessage
                                        name="emailId"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Frequency{" "}
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7 reactSelect">
                                      <Select
                                        className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                                        name="frequencyDataValue"
                                        isMulti
                                        onInputChange={this.handleChange}
                                        onChange={(e) => {
                                          this.frequencyChange(e);
                                        }}
                                        value={this.state.frequencySelected}
                                        options={[
                                          { label: "6 Months", value: 6 },
                                          { label: "5 Months", value: 5 },
                                          { label: "4 Months", value: 4 },
                                          { label: "3 Months", value: 3 },
                                          { label: "2 Months", value: 2 },
                                          { label: "1 Months", value: 1 },
                                          {
                                            label: "15 Days",
                                            value: "15 Days",
                                          },
                                        ].map((item) => ({
                                          label: item.label,
                                          value: item.label,
                                        }))}
                                      />
                                      <ErrorMessage
                                        name="frequencyDataValue"
                                        component="div"
                                        className="text-red"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Asset Name
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7 reactSelect">
                                      <label>
                                        {this.state.initialValues.assetName}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-12">
                                <div className="inputContainer col-lg-12 col-md-12">
                                  <div className="row mb-3">
                                    <label className="col-sm-4 col-form-label">
                                      Brand Name
                                      <span className="astrik">*</span>
                                    </label>
                                    <div className="col-sm-7 reactSelect">
                                      {this.BrandList()}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {this.props.match.params.id !== undefined ? (
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="btnContainer">
                                    <div>
                                      <button
                                        type="submit"
                                        disabled={isSubmitting}
                                      >
                                        Update
                                      </button>
                                      <button
                                        type="button"
                                        onClick={(e) => {
                                          this.checkDelete(e);
                                        }}
                                      >
                                        <FontAwesomeIcon icon={faTimes} />{" "}
                                        Delete
                                      </button>
                                      <button
                                        type="submit"
                                        disabled={isSubmitting}
                                      >
                                        <Link to="/masters/asset-detail">
                                          <FontAwesomeIcon icon={faUndo} />{" "}
                                          Reset
                                        </Link>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="row">
                                <div className="col-lg-7 offset-lg-4">
                                  <div className="btnContainer text-center">
                                    <div style={{ float: "none" }}>
                                      <button
                                        type="submit"
                                        style={{ borderRadius: "0" }}
                                      >
                                        Save Alert
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </Form>
                        <PopupMessage
                          open={this.state.messsagePopup}
                          content={this.state.popupContent}
                          redirectAfterSave={this.redirectAfterSave}
                        />
                      </div>
                    )}
                  </Formik>
                  <PopupMessage
                    open={this.state.messsagePopup}
                    content={this.state.popupContent}
                    redirectAfterSave={this.redirectAfterSave}
                  />
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
        <BottomNav />
      </div>
    );
  }
}

export default withRouter(Alerts);
